/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import xClose from "../../../../images/x_close.svg"
import { windowObject } from "../../../../utils/browser-helpers"
import * as s from "./css/modal-info-prezzo.module.css"
import arrowDx from "../../../../images/arrow_dx.png"
import { urls } from "../../../../constants"
import activateMembership from "../../../../images/activate_membership.png"
import openStoreInApp from "../../../../images/open_store_in_app.png"
import { isMobile, isAndroid, isIOS } from "react-device-detect";

const Item = ({ title, linkClass, boxTitle, boxTitleClass, boxImageSrc, onClick = null }) => {
    return <>
        <div className={`flex flex-col items-center col-span-4 desktop:col-span-5 ${s.itemContainer}`}>
            <div className="font-rg text-p16 text-center desktop:text-p18">{title}</div>
            <div className="flex-grow"></div>
            <a className={`w-full flex flex-1 flex-col desktop:flex-row  items-center cursor-pointer ${s.itemBoxContainer} ${linkClass}`} onClick={onClick}>
                <img src={boxImageSrc} style={{ height: '44px' }} alt="dettaglio prezzo" />
                <div className={`font-bd flex-grow text-p16 desktop:text-p18 ml-0 mt-p12 desktop:ml-p20 desktop:mt-0 ${boxTitleClass}`} style={{ lineHeight: '27px' }}>{boxTitle}</div>
                <img src={arrowDx} className="hidden desktop:block" style={{ width: '10px' }} alt="vedi dettaglio prezzo" />
            </a>
        </div>
    </>
}

const ModalAttivaTinaba = ({ project, visible, requestClose, goNext }) => {

    const onOpenInApp = async () => {
        if (isMobile) {
            const deeplinkUrl = `https://deeplink.tinaba.it/?state=purchases`;
            const wObj = windowObject();
            if(wObj)
            {
                wObj.open(deeplinkUrl);
            }
        }
        else {
            const wObj = windowObject();
            if (wObj) {
                wObj.open(`/${project.alias}/qrcode`);
            }
        }
    }

    const onExitTap = () => {
        if (requestClose) {
            requestClose();
        }
    }

    return (
        visible &&
        <>
            <div className={`items-center desktop:justify-center flex flex-col ${s.container}`}>
                <div className={`bg-white relative ${s.containerContent}`}>
                    <div className={`container-grid relative flex-col desktop:flex-row`}>
                        <div className="col-span-4 desktop:col-span-12">
                            <div className={`flex flex-col ${s.containerInfo}`}>
                                <div className="text-center text-black font-md text-2 desktop:text-24 leading-16" style={{ marginTop: '48px' }}>Con Tinaba Hit</div>
                            </div>
                        </div>
                        <div aria-hidden="true" className="hidden desktop:flex absolute cursor-pointer" style={{ fontSize: '32px', right: '30px', top: '33px' }} onClick={onExitTap}>
                            <img src={xClose} alt="close" />
                        </div>
                    </div>
                    <div className="container-grid relative flex-col desktop:flex-row" style={{ paddingBottom: '56px' }}>
                        <Item title="Approfitta dei vantaggi della tua membership" linkClass="go-to-store-in-app" boxTitle="Apri lo store in App" boxTitleClass="text-primary" boxImageSrc={openStoreInApp} onClick={() => {
                            // Apre l'app
                            onOpenInApp();
                            requestClose();
                        }} />
                        <Item title="Voglio sapere di più per avere lo sconto" linkClass="attiva-membership-hit" boxTitle="Attiva la membership" boxTitleClass="text-black" boxImageSrc={activateMembership} onClick={() => {
                            requestClose();
                            const wObj = windowObject();
                            if (wObj) {
                                wObj.open(urls.ATTIVA_TINABA_HIT);
                            }
                        }} />
                    </div>
                    <div aria-hidden="true" className={`flex desktop:hidden absolute cursor-pointer ${s.containerImgClose}`} onClick={onExitTap}>
                        <img src={xClose} alt="close" className={`${s.imgClose}`} />
                    </div>
                </div>
            </div>
        </>
    )
}


export default ModalAttivaTinaba
